import FsLightbox, { FsLightboxProps } from 'fslightbox-react';
import React, { FC } from 'react';
import { Image as ImageComponent } from 'react-bootstrap';
import { Image } from '../Image';
import styles from './GalleryLightbox.module.scss';
import { GalleryLightboxCustomSource } from './GalleryLightboxCustomSource';
import { GalleryLightboxCustomSourceTwo } from './GalleryLightboxCustomSourceTwo';
import { GalleryLightboxIframe } from './GalleryLightboxIframe';
import { GalleryLightboxVideo } from './GalleryLightboxVideo';

type GalleryLightboxProps = Omit<FsLightboxProps, 'sources'> & {
	sources?: (string | JSX.Element)[];
	promoBox?: JSX.Element;
};

export const GalleryLightbox: FC<GalleryLightboxProps> = ({ sources, promoBox, ...props }) => {
	const gallerySources = promoBox
		? sources?.map((source) => (
				<div>
					{promoBox}
					{typeof source === 'string' ? (
						<Image>
							<ImageComponent src={source} />
						</Image>
					) : (
						source
					)}
				</div>
		  ))
		: sources;

	return (
		<div className={styles.galleryLightbox}>
			<FsLightbox {...props} sources={gallerySources as any} />
		</div>
	);
};

export default Object.assign(GalleryLightbox, {
	CustomSource: GalleryLightboxCustomSource,
	CustomSourceTwo: GalleryLightboxCustomSourceTwo,
	Iframe: GalleryLightboxIframe,
	Video: GalleryLightboxVideo,
});
